import { Box } from "@mui/material";
import { ReactNode } from "react";


export default ({ children }: { children: ReactNode }) =>
  <div>
    {children}
  </div>